(function () {
  function initAccordion(section) {
    if (!section) return;

    var items = section.querySelectorAll('.jh-accordion-item');

    items.forEach(function (item) {
      var button = item.querySelector('.jh-accordion-toggle');

      if (!button || button.dataset.bound === 'true') return;

      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        var allowSingle = section.dataset.onlyOneOpen === 'true';
        var isOpen = item.classList.contains('is-open');

        if (allowSingle) {
          items.forEach(function (otherItem) {
            otherItem.classList.remove('is-open');

            var otherButton = otherItem.querySelector('.jh-accordion-toggle');

            if (otherButton) {
              otherButton.setAttribute('aria-expanded', 'false');
            }
          });
        }

        item.classList.toggle('is-open', !isOpen);
        button.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initAllAccordions(scope) {
    scope = scope || document;

    var sections = scope.querySelectorAll('.jh-accordion-section');

    sections.forEach(function (section) {
      initAccordion(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllAccordions(document);
    });
  } else {
    initAllAccordions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllAccordions(event.target);
  });
})();